import { ObservationEntity } from '../../coaching-base/config';
import { EventResult, FocusContainerDto } from '../../coaching-base/general';
import { EventParticipantDto } from '../../coaching-base/general/event-participant-observation-dto.model';
import { NotificationScenario } from '../../coaching-base/notifications';
import { BehaviourItem } from '../../coaching-tags/models/behaviour.coaching.model';
import { MetricItem } from '../../coaching-tags/models/metric.coaching.model';
import { QueueItem } from '../../coaching-tags/models/queue.coaching.model';
import { SubBehaviourItem } from '../../coaching-tags/models/subbehaviour.coaching.model';
import { FocusShallow } from '../../coaching-tags/tags/tags.model';
import { createAction, PayloadAction } from '../../store.model';
import { ObservationCommitDialogItem } from '../observation-commit-dialog/observation-commit-dialog.component';

import { ObservationExtraOptions } from './observation-extra-options.model';
import { DraftIdByIdentifier } from './observation-focus-draft-id-identifier.model';
import { ObservationFormValue } from './observation-form-value.model';
import {
    NavigationScenario,
    NavigationScenarioOptions,
    ObservationMode,
} from './observation.model';

export enum ActionType {
    COACHING_OBSERVATION__ROOT__RELOAD = 'COACHING_OBSERVATION__ROOT__RELOAD',
    COACHING_OBSERVATION__ROOT__RELOAD_RESULT = 'COACHING_OBSERVATION__ROOT__RELOAD_RESULT',
    COACHING_OBSERVATION__ROOT__SAVE = 'COACHING_OBSERVATION__ROOT__SAVE',
    COACHING_OBSERVATION__ROOT__SAVE_RESULT = 'COACHING_OBSERVATION__ROOT__SAVE_RESULT',
    COACHING_OBSERVATION__ROOT__SEND_NOTIFICATION = 'COACHING_OBSERVATION__ROOT__SEND_NOTIFICATION',
    COACHING_OBSERVATION__ROOT__SEND_NOTIFICATION_RESULT = 'COACHING_OBSERVATION__ROOT__SEND_NOTIFICATION_RESULT',
    COACHING_OBSERVATION__ROOT__NAVIGATE = 'COACHING_OBSERVATION__ROOT__NAVIGATE',
    COACHING_OBSERVATION__ROOT__DISMISS_MESSAGE = 'COACHING_OBSERVATION__ROOT__DISMISS_MESSAGE',
    COACHING_OBSERVATION__ROOT__DELETE = 'COACHING_OBSERVATION__ROOT__DELETE',
    COACHING_OBSERVATION__ROOT__DELETE_RESULT = 'COACHING_OBSERVATION__ROOT__DELETE_RESULT',
    COACHING_OBSERVATION__ROOT__SET_MODE = 'COACHING_OBSERVATION__ROOT__SET_MODE',
}

export interface RootReloadAction {
    performerId: number;
    observationId?: number;
    observerId?: number;
    loadActive?: boolean;
    activeMetricId?: number;
    draftCommitmentId?: string;
    commitmentId?: number;
    isGeneric?: boolean;
    focus?: FocusShallow;
    extraOptions?: ObservationExtraOptions;
}

export const rootReload = createAction<ActionType, RootReloadAction>(
    ActionType.COACHING_OBSERVATION__ROOT__RELOAD,
);

export interface RootReloadResultAction extends RootReloadAction {
    behaviours?: BehaviourItem[];
    subBehaviours?: SubBehaviourItem[];
    metrics?: MetricItem[];
    coachingEvent?: ObservationEntity;
    event?: EventResult;
    performer?: EventParticipantDto;
    observer?: EventParticipantDto;
    focusContainers?: FocusContainerDto[];
    queues?: QueueItem[];
}

export const rootReloadResult = createAction<
    ActionType,
    RootReloadResultAction
>(ActionType.COACHING_OBSERVATION__ROOT__RELOAD_RESULT);

/// //////////////////////

export interface RootSaveAction {
    formValue: ObservationFormValue;
    share: boolean;
    publish: boolean;
    actions?: Array<PayloadAction<any, any>>;
    primaryBehaviourId?: number;
    primarySubBehaviourId?: number;
    latestCommitmentEventId?: number;
    userId?: number;
    activeMetricId?: number;
    isGeneric?: boolean;
    dialogItems?: ObservationCommitDialogItem[];
}

export const rootSave = createAction<ActionType, RootSaveAction>(
    ActionType.COACHING_OBSERVATION__ROOT__SAVE,
);

export interface RootSaveResultAction extends RootSaveAction {
    event?: EventResult;
    performer?: EventParticipantDto;
    observer?: EventParticipantDto;
    focusContainers?: FocusContainerDto[];
    nextCommitmentDraftId?: string;
    draftIdByIdentifier?: DraftIdByIdentifier;
    nextCommitmentId?: number;
}

export const rootSaveResult = createAction<ActionType, RootSaveResultAction>(
    ActionType.COACHING_OBSERVATION__ROOT__SAVE_RESULT,
);

/// //////////////////////

export interface RootSendNotificationAction {
    scenario: NotificationScenario;
}

export const rootSendNotification = createAction<
    ActionType,
    RootSendNotificationAction
>(ActionType.COACHING_OBSERVATION__ROOT__SEND_NOTIFICATION);

export interface RootSendNotificationResultAction
    extends RootSendNotificationAction {}

export const rootSendNotificationResult = createAction<
    ActionType,
    RootSendNotificationResultAction
>(ActionType.COACHING_OBSERVATION__ROOT__SEND_NOTIFICATION_RESULT);

/// //////////////////////

export interface RootNavigateAction {
    scenario: NavigationScenario;
    opts?: NavigationScenarioOptions;
}

export const rootNavigate = createAction<ActionType, RootNavigateAction>(
    ActionType.COACHING_OBSERVATION__ROOT__NAVIGATE,
);

/// //////////////////////

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootDismissMessageAction {}

// no arg since there's only one
export const rootDismissMessage = createAction<
    ActionType,
    RootDismissMessageAction
>(ActionType.COACHING_OBSERVATION__ROOT__DISMISS_MESSAGE);

/// ////////////////////////

export interface RootDeleteAction {
    observationId?: number;
    actions?: Array<PayloadAction<any, any>>;
}

export const rootDelete = createAction<ActionType, RootDeleteAction>(
    ActionType.COACHING_OBSERVATION__ROOT__DELETE,
);

export interface RootDeleteResultAction extends RootDeleteAction {
    success?: boolean;
}

export const rootDeleteResult = createAction<
    ActionType,
    RootDeleteResultAction
>(ActionType.COACHING_OBSERVATION__ROOT__DELETE_RESULT);

/// //////////////////////

export interface RootSetModeAction {
    mode: ObservationMode;
}

export const rootSetMode = createAction<ActionType, RootSetModeAction>(
    ActionType.COACHING_OBSERVATION__ROOT__SET_MODE,
);
